var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({ width: _vm.w, height: _vm.h }),attrs:{"id":_vm.mapId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }